import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    createNewArticleCommissionModel,
    deleteArticleCommissionModel,
    getArticleCommissionModel,
    updateArticleCommissionModel,
} from 'src/api/article-management';
import {
    CREATE_ARTICLE_COMMISSION_MODEL,
    DELETE_ARTICLE_COMMISSION_MODEL,
    FETCH_ARTICLE_COMMISSION_MODEL,
    requestArticleCommissionModel,
    requestArticleCommissionModelFailure,
    requestArticleCommissionModelSuccess,
    requestCreateArticleCommissionModel,
    requestCreateArticleCommissionModelFailure,
    requestCreateArticleCommissionModelSuccess,
    requestDeleteArticleCommissionModel,
    requestDeleteArticleCommissionModelFailure,
    requestDeleteArticleCommissionModelSuccess,
    requestUpdateArticleCommissionModel,
    requestUpdateArticleCommissionModelFailure,
    requestUpdateArticleCommissionModelSuccess,
    UPDATE_ARTICLE_COMMISSION_MODEL,
} from './actions';

function* fetchArticleCommissionModelSaga(action: AnyAction): SagaIterator {
    yield put(requestArticleCommissionModel());

    const { error, response } = yield call(getArticleCommissionModel, action.pageable);

    if (error) {
        yield put(requestArticleCommissionModelFailure(error));
    } else {
        yield put(requestArticleCommissionModelSuccess(response));
    }
}

function* createArticleCommissionModelSaga(action: AnyAction): SagaIterator {
    yield put(requestCreateArticleCommissionModel());

    const { error, response } = yield call(createNewArticleCommissionModel, action.commissionModelDto);

    if (error) {
        yield put(requestCreateArticleCommissionModelFailure(error));
    } else {
        yield put(requestCreateArticleCommissionModelSuccess(response));
    }
}

function* updateArticleCommissionModelSaga(action: AnyAction): SagaIterator {
    yield put(requestUpdateArticleCommissionModel());

    const { error, response } = yield call(updateArticleCommissionModel, action.commissionModelDto);

    if (error) {
        yield put(requestUpdateArticleCommissionModelFailure(error));
    } else {
        yield put(requestUpdateArticleCommissionModelSuccess(response));
    }
}

function* deleteArticleCommissionModelSaga(action: AnyAction): SagaIterator {
    yield put(requestDeleteArticleCommissionModel());

    const { error, response } = yield call(deleteArticleCommissionModel, action.commissionModelId);

    if (error) {
        yield put(requestDeleteArticleCommissionModelFailure(error));
    } else {
        yield put(requestDeleteArticleCommissionModelSuccess(response));
    }
}

export function* generateFetchArticleCommissionModelWatcher() {
    yield takeLatest(FETCH_ARTICLE_COMMISSION_MODEL, fetchArticleCommissionModelSaga);
}

export function* generateCreateArticleCommissionModelWatcher() {
    yield takeLatest(CREATE_ARTICLE_COMMISSION_MODEL, createArticleCommissionModelSaga);
}

export function* generateUpdateArticleCommissionModelWatcher() {
    yield takeLatest(UPDATE_ARTICLE_COMMISSION_MODEL, updateArticleCommissionModelSaga);
}

export function* generateDeleteArticleCommissionModelWatcher() {
    yield takeLatest(DELETE_ARTICLE_COMMISSION_MODEL, deleteArticleCommissionModelSaga);
}
